// http://varun.ca/icon-component/

import classNames from 'class-names';
import PropTypes from 'prop-types';
import React from 'react';

const Icon = ({
  name,
  className,
  width = '100%',
  height = '100%',
  ...props
}) => (
  <span
    aria-label={name}
    className={classNames('icon', className, {
      [`icon--${name}`]: true,
    })}
    {...props}
  >
    <svg
      className="icon--svg"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
    >
      <use xlinkHref={`#spritemap_${name}`} />
    </svg>
  </span>
);

Icon.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default Icon;
